import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

/**
 * Injects global CSS for ApexCharts tooltips and legend.
 * Rendered once in ThemeConfig (theme/index.js).
 */
export default function ApexChartsGlobalStyles() {
  const theme = useTheme();

  useEffect(() => {
    const shadow = theme.customShadows?.z24 ?? '0 0 2px 0 rgba(0,0,0,.14)';
    const textPrimary = theme.palette?.text?.primary ?? '#212121';
    const bgDefault = theme.palette?.background?.default ?? '#fff';
    const borderRadius = theme.shape?.borderRadius ?? 8;
    const grey16 = theme.palette?.grey?.[500_16] ?? 'rgba(0,0,0,0.08)';
    const textSecondary = theme.palette?.text?.secondary ?? '#757575';
    const bgPaper = theme.palette?.background?.paper ?? '#fff';
    const fontWeightBold = theme.typography?.fontWeightBold ?? 700;
    const style = document.createElement('style');
    style.setAttribute('data-apexcharts-global', '1');
    style.textContent = [
      `.apexcharts-tooltip,.apexcharts-xaxistooltip{border:0!important;box-shadow:${shadow}!important;color:${textPrimary}!important;border-radius:${borderRadius}px!important;background:${bgDefault}!important}`,
      `.apexcharts-tooltip-title{border:0!important;font-weight:${fontWeightBold};background:${grey16}!important;color:${textSecondary}}`,
      `.apexcharts-xaxistooltip-bottom:before{border-bottom-color:transparent!important}`,
      `.apexcharts-xaxistooltip-bottom:after{border-bottom-color:${bgPaper}!important}`,
      `.apexcharts-legend{padding:0!important}`,
      `.apexcharts-legend-series{align-items:center;display:flex!important}`,
      `.apexcharts-legend-marker{margin-top:-2px!important;margin-right:8px!important}`,
      `.apexcharts-legend-text{line-height:18px;text-transform:capitalize}`,
    ].join('');
    document.head.appendChild(style);
    return () => { if (style.parentNode) document.head.removeChild(style); };
  }, [theme]);

  return null;
}
